import React, { useEffect, useMemo, useState } from 'react';
import {
  Card,
  Table,
  Button,
  Tag,
  Space,
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  message,
  Switch,
  Row,
  Col,
  Popconfirm,
  Tooltip,
  Typography,
  Radio,
} from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined,
  VideoCameraOutlined,
  TrophyOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

const { Option } = Select;
const { Text } = Typography;

const CardManagement: React.FC = () => {
  const getCurrentUser = () => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser).name : '管理员';
  };

  const [modules, setModules] = useState([
    {
      id: '1',
      name: '直播间卡片',
      type: '直播间卡片',
      typeId: 'live_room',
      page: 'home',
      CardType: 'live_room',
      UIType: '',
      AppLink: '',
      description: '展示热门直播间信息',
      status: '已启用',
      cardCount: 4,
      updatedAt: '2025-01-27 14:30:00',
      updatedBy: '管理员',
    },
    {
      id: '3',
      name: '首页轮播图',
      type: '轮播图',
      typeId: 'banner',
      page: 'home',
      CardType: 'banner',
      UIType: 'banner.carousel',
      AppLink: '',
      description: '展示顶部Banner轮播',
      status: '已启用',
      cardCount: 2,
      updatedAt: '2025-01-27 15:10:00',
      updatedBy: '管理员',
    },
    {
      id: '4',
      name: '广播消息',
      type: '广播消息',
      typeId: 'broadcast',
      page: 'home',
      CardType: 'broadcast',
      UIType: 'notice.marquee',
      AppLink: '',
      description: '展示顶部跑马灯公告',
      status: '已启用',
      cardCount: 1,
      updatedAt: '2025-01-27 15:12:00',
      updatedBy: '管理员',
    },
    {
      id: '5',
      name: '游戏分类',
      type: '游戏分类',
      typeId: 'game_category',
      page: 'home',
      CardType: 'game_category',
      UIType: 'category.sidebar',
      AppLink: '',
      description: '展示频道分类入口',
      status: '已启用',
      cardCount: 6,
      updatedAt: '2025-01-27 15:15:00',
      updatedBy: '管理员',
    },
    {
      id: '6',
      name: '游戏厂商',
      type: '游戏厂商',
      typeId: 'vendor',
      page: 'home',
      CardType: 'vendor',
      UIType: 'vendor.hscroll',
      AppLink: '',
      description: '展示热门直播品牌/厂商',
      status: '已启用',
      cardCount: 2,
      updatedAt: '2025-01-27 15:18:00',
      updatedBy: '管理员',
    },
    {
      id: '7',
      name: '子游戏',
      type: '子游戏',
      typeId: 'game',
      page: 'home',
      CardType: 'game',
      UIType: 'game.hscroll',
      AppLink: '',
      description: '展示热门游戏列表',
      status: '已启用',
      cardCount: 4,
      updatedAt: '2025-01-27 15:20:00',
      updatedBy: '管理员',
    },
    {
      id: '8',
      name: '底部文案',
      type: '底部文案',
      typeId: 'footer_text',
      page: 'home',
      CardType: 'footer_text',
      UIType: 'footer.text.default',
      AppLink: '',
      description: '展示平台说明文本',
      status: '已启用',
      cardCount: 1,
      updatedAt: '2025-01-27 15:22:00',
      updatedBy: '管理员',
    },
    {
      id: '9',
      name: '底部联系方式',
      type: '底部联系方式',
      typeId: 'footer_contacts',
      page: 'home',
      CardType: 'footer_contacts',
      UIType: 'footer.contacts.row',
      AppLink: '',
      description: '展示社媒跳转入口',
      status: '已启用',
      cardCount: 3,
      updatedAt: '2025-01-27 15:25:00',
      updatedBy: '管理员',
    },
  ]);

  const [liveCards, setLiveCards] = useState([
    {
      id: '1',
      title: '财神直播间 - 今晚爆大奖！',
      hostName: '主播小财神',
      hotTag: '热门',
      gameName: '超级王牌',
      viewerCount: 12345,
      liveStatus: '直播中',
      jumpUrl: 'https://example.com/live/room/123',
      sortWeight: 100,
      isEnabled: true,
      updatedAt: '2025-01-27 14:30:00',
      updatedBy: '管理员',
    },
    {
      id: '2',
      title: '黄金转盘时间',
      hostName: '转盘王',
      hotTag: '推荐',
      gameName: '幸运转盘',
      viewerCount: 8765,
      liveStatus: '预告中',
      jumpUrl: 'https://example.com/live/room/124',
      sortWeight: 90,
      isEnabled: true,
      updatedAt: '2025-01-27 14:25:00',
      updatedBy: '李四',
    },
    {
      id: '3',
      title: '幸运大转盘专场',
      hostName: '幸运主播',
      hotTag: '热门',
      gameName: '刮刮乐',
      viewerCount: 5432,
      liveStatus: '直播中',
      jumpUrl: 'https://example.com/live/room/125',
      sortWeight: 80,
      isEnabled: true,
      updatedAt: '2025-01-27 14:20:00',
      updatedBy: '王五',
    },
    {
      id: '4',
      title: '每日签到福利',
      hostName: '福利君',
      hotTag: '福利',
      gameName: '每日签到',
      viewerCount: 2341,
      liveStatus: '已结束',
      jumpUrl: 'https://example.com/live/room/126',
      sortWeight: 70,
      isEnabled: false,
      updatedAt: '2025-01-27 14:15:00',
      updatedBy: '赵六',
    },
  ]);

  const [sportsCards, setSportsCards] = useState([
    {
      id: '1',
      matchType: '足球',
      matchTime: '2025-01-27 16:30',
      teamA: '皇家马德里',
      teamB: '巴塞罗那',
      oddsA: 2.5,
      oddsB: 3.2,
      oddsDraw: 2.8,
      matchStatus: '未开始',
      jumpUrl: 'https://example.com/sports/match/456',
      sortWeight: 100,
      isEnabled: true,
      updatedAt: '2025-01-27 14:30:00',
      updatedBy: '管理员',
    },
    {
      id: '2',
      matchType: '篮球',
      matchTime: '2025-01-28 20:00',
      teamA: '洛杉矶湖人',
      teamB: '金州勇士',
      oddsA: 1.8,
      oddsB: 2.0,
      oddsDraw: null,
      matchStatus: '未开始',
      jumpUrl: 'https://example.com/sports/match/457',
      sortWeight: 95,
      isEnabled: true,
      updatedAt: '2025-01-27 14:25:00',
      updatedBy: '张三',
    },
    {
      id: '3',
      matchType: '电竞',
      matchTime: '2025-01-27 13:00',
      teamA: 'SK战队',
      teamB: 'IG战队',
      oddsA: 2.2,
      oddsB: 1.9,
      oddsDraw: null,
      matchStatus: '进行中',
      jumpUrl: 'https://example.com/sports/match/458',
      sortWeight: 90,
      isEnabled: true,
      updatedAt: '2025-01-27 14:20:00',
      updatedBy: '李四',
    },
  ]);

  const [cardModalVisible, setCardModalVisible] = useState(false);
  const [cardEditVisible, setCardEditVisible] = useState(false);
  const [currentModule, setCurrentModule] = useState<any>(null);
  const [currentCards, setCurrentCards] = useState<any[]>([]);
  const [editingCard, setEditingCard] = useState<any>(null);
  const [cardForm] = Form.useForm();
  const [moduleForm] = Form.useForm();
  const [moduleAddVisible, setModuleAddVisible] = useState(false);
  const [editingModule, setEditingModule] = useState<any>(null);

  // 热门直播弹窗与数据
  type GameType = '体育' | '老虎机' | '捕鱼' | '棋牌' | '街机' | '真人';
  type HotItemType = 'live' | 'game' | 'vendor';
  type HotItem = { id: string; title: string; elementType: HotItemType; heat?: number; gameType?: GameType; startTime?: number; isGray?: boolean; status?: 'online'|'offline'; coverUrl?: string; logoUrl?: string; vendor?: string };
  const [liveHotVisible, setLiveHotVisible] = useState(false);
  const [liveHotItems, setLiveHotItems] = useState<HotItem[]>([]);
  const [liveHotSort, setLiveHotSort] = useState<'heat' | 'gameType' | 'startTime'>('heat');
  const [currentHotLabel, setCurrentHotLabel] = useState<string>('hot_game');
  const [hotLabels, setHotLabels] = useState<{ key: string; name: string }[]>([
    { key: 'hot_game', name: 'Hot Game' },
    { key: 'live_brands', name: 'Live Brands' }
  ]);
  const [renameName, setRenameName] = useState<string>('Hot Game');

  const genMockLive = (n = 12): HotItem[] => {
    const types: GameType[] = ['体育', '老虎机', '捕鱼', '棋牌', '街机'];
    const list: HotItem[] = [];
    for (let i = 0; i < n; i++) {
      const heat = Math.floor(Math.random() * 100000) + 1000;
      const startOffset = Math.floor(Math.random() * 6 * 60 * 60 * 1000);
      list.push({
        id: `hot_${Date.now()}_${i}`,
        title: `内容 #${i + 1}`,
        elementType: 'game',
        heat,
        gameType: types[i % types.length],
        startTime: Date.now() - startOffset,
        coverUrl: `https://picsum.photos/200/260?g=${i}`
      });
    }
    return list;
  };

  const genLive = (n = 8): HotItem[] => {
    const list: HotItem[] = [];
    for (let i = 0; i < n; i++) {
      const heat = Math.floor(Math.random() * 100000) + 5000;
      const startOffset = Math.floor(Math.random() * 6 * 60 * 60 * 1000);
      list.push({
        id: `live_${Date.now()}_${i}`,
        title: `直播 #${i + 1}`,
        elementType: 'live',
        heat,
        gameType: '真人',
        startTime: Date.now() - startOffset,
        isGray: Math.random() > 0.7,
        status: Math.random() > 0.2 ? 'online' : 'offline',
        coverUrl: `https://picsum.photos/200/260?l=${i}`
      });
    }
    return list;
  };

  const writeBackHotItems = (label: string, items: HotItem[]) => {
    setModules(prev => prev.map(m => {
      if (m.typeId !== 'hot') return m;
      const copy: any = { ...m };
      copy.hotContent = copy.hotContent || { labels: [{ key: 'live_room', name: 'Hot Game' }], itemsByLabel: {} };
      copy.hotContent.itemsByLabel = { ...(copy.hotContent.itemsByLabel || {}), [label]: items };
      return copy;
    }));
  };

  const openLiveHot = () => {
    const hot = modules.find(m => m.typeId === 'hot') as any;
    const labels = hot?.hotContent?.labels || [
      { key: 'hot_game', name: 'Hot Game' },
      { key: 'live_brands', name: 'Live Brands' }
    ];
    setHotLabels(labels);
    const initialLabel = labels[0]?.key || 'hot_game';
    setCurrentHotLabel(initialLabel);
    setRenameName(labels.find((l: any) => l.key === initialLabel)?.name || '');
    const items = hot?.hotContent?.itemsByLabel?.[initialLabel] || genMockLive();
    setLiveHotItems(items);
    setLiveHotSort('heat');
    setLiveHotVisible(true);
  };

  const addHotLabel = () => {
    const newKey = `custom_${Date.now()}`;
    const newLabel = { key: newKey, name: 'New Label' };
    setHotLabels(prev => [...prev, newLabel]);
    // 切换到新标签并清空数据
    writeBackHotItems(currentHotLabel, liveHotItems);
    setCurrentHotLabel(newKey);
    setRenameName('New Label');
    setLiveHotItems([]);
  };

  const deleteHotLabel = () => {
    if (hotLabels.length <= 1) {
      message.warning('至少保留一个标签');
      return;
    }
    const idx = hotLabels.findIndex(l => l.key === currentHotLabel);
    const nextLabels = hotLabels.filter(l => l.key !== currentHotLabel);
    setHotLabels(nextLabels);
    // 切换到相邻标签
    const next = nextLabels[Math.max(0, idx - 1)];
    setCurrentHotLabel(next.key);
    setRenameName(next.name);
    const hot = modules.find(m => m.typeId === 'hot') as any;
    const nextItems = hot?.hotContent?.itemsByLabel?.[next.key] || [];
    setLiveHotItems(nextItems);
  };

  const applyLiveHotSort = (key: 'heat' | 'gameType' | 'startTime') => {
    setLiveHotSort(key);
    setLiveHotItems(prev => {
      const arr = [...prev];
      if (key === 'heat') arr.sort((a, b) => (b.heat ?? -Infinity) - (a.heat ?? -Infinity));
      if (key === 'gameType') arr.sort((a, b) => (a.gameType || '').toString().localeCompare((b.gameType || '').toString()));
      if (key === 'startTime') arr.sort((a, b) => (b.startTime ?? 0) - (a.startTime ?? 0));
      return arr;
    });
  };

  const moveLiveHot = (index: number, delta: number) => {
    const next = index + delta;
    if (next < 0 || next >= liveHotItems.length) return;
    const draft = [...liveHotItems];
    const [it] = draft.splice(index, 1);
    draft.splice(next, 0, it);
    setLiveHotItems(draft);
  };

  const handleViewDetail = (module: any) => {
    setCurrentModule(module);
    if (module.typeId === 'live_room') {
      setCurrentCards(liveCards);
    } else if (module.typeId === 'sports_match') {
      setCurrentCards(sportsCards);
    } else if (module.typeId === 'banner') {
      setCurrentCards(banners);
    } else if (module.typeId === 'broadcast') {
      setCurrentCards(broadcasts);
    } else if (module.typeId === 'game_category') {
      setCurrentCards(categories);
    } else if (module.typeId === 'vendor') {
      setCurrentCards(vendorsData);
    } else if (module.typeId === 'game') {
      setCurrentCards(gamesData);
    } else if (module.typeId === 'footer_text') {
      setCurrentCards(footerTexts);
    } else if (module.typeId === 'footer_contacts') {
      setCurrentCards(footerContacts);
    }
    setCardModalVisible(true);
  };

  const handleEditModule = (module: any) => {
    setEditingModule(module);
    moduleForm.setFieldsValue({
      page: module.page || 'home',
      typeId: module.typeId,
      name: module.name,
      uiCode: module.UIType || module.uiCode,
      dataSource: module.dataSource,
      jumpType: module.jumpType || (module.AppLink && module.AppLink.startsWith('http') ? 'fixedUrl' : 'params'),
      jumpUrl: module.jumpUrl || (module.AppLink && module.AppLink.startsWith('http') ? module.AppLink : undefined),
      jumpParams: module.jumpParams || (module.AppLink && !module.AppLink.startsWith('http') ? module.AppLink : undefined),
      description: module.description,
    });
    setModuleAddVisible(true);
  };

  const handleDeleteModule = (moduleId: string) => {
    setModules(prev => prev.filter(m => m.id !== moduleId));
    if (currentModule?.id === moduleId) setCardModalVisible(false);
  };

  const handleAddCard = () => {
    setEditingCard(null);
    cardForm.resetFields();
    cardForm.setFieldsValue({ isEnabled: true, sortWeight: 100 });
    setCardEditVisible(true);
  };

  const handleEditCard = (card: any) => {
    setEditingCard(card);
    const formValues = { ...card };
    cardForm.setFieldsValue(formValues);
    setCardEditVisible(true);
  };

  const handleDeleteCard = (id: string) => {
    if (currentModule?.typeId === 'live_room') {
      const newCards = liveCards.filter((c) => c.id !== id);
      setLiveCards(newCards);
      setCurrentCards(newCards);
      setModules(modules.map(m => m.typeId === 'live_room' ? { ...m, cardCount: newCards.length } : m));
    } else {
      const newCards = sportsCards.filter((c) => c.id !== id);
      setSportsCards(newCards);
      setCurrentCards(newCards);
      setModules(modules.map(m => m.typeId === 'sports_match' ? { ...m, cardCount: newCards.length } : m));
    }
    message.success('删除成功');
  };

  const handleSaveCard = () => {
    cardForm.validateFields().then((values) => {
      const now = dayjs().format('YYYY-MM-DD HH:mm:ss');
      const currentUser = getCurrentUser();
      
      if (editingCard) {
        const updatedCard = { ...editingCard, ...values, updatedAt: now, updatedBy: currentUser };
        
        if (currentModule?.typeId === 'live_room') {
          const newCards = liveCards.map(c => c.id === editingCard.id ? updatedCard : c);
          setLiveCards(newCards);
          setCurrentCards(newCards);
        } else {
          const newCards = sportsCards.map(c => c.id === editingCard.id ? updatedCard : c);
          setSportsCards(newCards);
          setCurrentCards(newCards);
        }
        message.success('编辑成功');
      } else {
        const newCard = {
          id: Date.now().toString(),
          ...values,
          createdAt: now,
          updatedAt: now,
          updatedBy: currentUser,
        };
        
        if (currentModule?.typeId === 'live_room') {
          const newCards = [...liveCards, newCard];
          setLiveCards(newCards);
          setCurrentCards(newCards);
          setModules(modules.map(m => m.typeId === 'live_room' ? { ...m, cardCount: newCards.length } : m));
        } else {
          const newCards = [...sportsCards, newCard];
          setSportsCards(newCards);
          setCurrentCards(newCards);
          setModules(modules.map(m => m.typeId === 'sports_match' ? { ...m, cardCount: newCards.length } : m));
        }
        message.success('新增成功');
      }
      
      setCardEditVisible(false);
      cardForm.resetFields();
      setEditingCard(null);
    }).catch(() => {
      message.error('表单验证失败');
    });
  };

  const moduleColumns = [
    {
      title: '模块名称',
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: any) => (
        <Space>
          {record.type === '直播间卡片' && <VideoCameraOutlined />}
          {record.type === '体育对战卡片' && <TrophyOutlined />}
          <span>{text}</span>
        </Space>
      ),
    },
    {
      title: '页面',
      dataIndex: 'page',
      key: 'page',
      render: () => <Tag>首页</Tag>,
    },
    {
      title: 'CardType',
      dataIndex: 'CardType',
      key: 'CardType',
      render: (v: string) => <Tag>{v}</Tag>,
    },
    {
      title: '模块类型',
      dataIndex: 'type',
      key: 'type',
      render: (type: string) => <Tag color={type === '直播间卡片' ? 'blue' : 'green'}>{type}</Tag>,
    },
    {
      title: 'UIType',
      dataIndex: 'UIType',
      key: 'UIType',
    },
    {
      title: 'AppLink',
      dataIndex: 'AppLink',
      key: 'AppLink',
      render: (v: string) => (v ? <Tooltip title={v}><Text ellipsis style={{ maxWidth: 200 }}>{v}</Text></Tooltip> : '-')
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: '卡片数量',
      dataIndex: 'cardCount',
      key: 'cardCount',
      render: (count: number) => <Tag color="blue">{count}条</Tag>,
    },
    {
      title: '最后修改人',
      dataIndex: 'updatedBy',
      key: 'updatedBy',
    },
    {
      title: '最后修改时间',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: any) => (
        <Space>
          {record.typeId !== 'live_room' && record.typeId !== 'hot' ? (
            <Button 
              type="primary" 
              size="small" 
              icon={<EyeOutlined />} 
              onClick={() => handleViewDetail(record)}
            >
              查看明细
            </Button>
          ) : null}
          {record.typeId === 'hot' ? (
            <Button size="small" onClick={openLiveHot}>热门内容</Button>
          ) : null}
          <Button size="small" icon={<EditOutlined />} onClick={() => handleEditModule(record)}>编辑</Button>
          <Popconfirm title="确认删除该模块？" onConfirm={() => handleDeleteModule(record.id)}>
            <Button danger size="small" icon={<DeleteOutlined />}>删除</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const getCardColumns = () => {
    if (currentModule?.typeId === 'live_room') {
      return [
        { title: '直播间标题', dataIndex: 'title', key: 'title', ellipsis: true },
        { title: '主播名称', dataIndex: 'hostName', key: 'hostName' },
        { 
          title: '热门标签', 
          dataIndex: 'hotTag', 
          key: 'hotTag', 
          render: (tag: string) => tag && <Tag color="red">{tag}</Tag> 
        },
        { 
          title: '观看人数', 
          dataIndex: 'viewerCount', 
          key: 'viewerCount', 
          render: (count: number) => count?.toLocaleString() || 0 
        },
        { 
          title: '直播状态', 
          dataIndex: 'liveStatus', 
          key: 'liveStatus',
          render: (status: string) => {
            const colorMap: Record<string, string> = { '直播中': 'green', '预告中': 'blue', '已结束': 'default' };
            return <Tag color={colorMap[status]}>{status}</Tag>;
          }
        },
        { 
          title: '跳转链接', 
          dataIndex: 'jumpUrl', 
          key: 'jumpUrl',
          ellipsis: true,
          render: (url: string) => (
            <Tooltip title={url}>
              <Text ellipsis style={{ maxWidth: 200 }}>
                {url}
              </Text>
            </Tooltip>
          )
        },
        { title: '最后修改人', dataIndex: 'updatedBy', key: 'updatedBy' },
        { title: '最后修改时间', dataIndex: 'updatedAt', key: 'updatedAt' },
        {
          title: '操作',
          key: 'action',
          width: 150,
          render: (_: any, record: any) => (
            <Space>
              <Button 
                size="small" 
                icon={<EditOutlined />} 
                onClick={() => handleEditCard(record)}
              >
                编辑
              </Button>
              <Popconfirm 
                title="确定要删除这条卡片吗?" 
                onConfirm={() => handleDeleteCard(record.id)}
              >
                <Button danger size="small" icon={<DeleteOutlined />}>
                  删除
                </Button>
              </Popconfirm>
            </Space>
          ),
        },
      ];
    } else if (currentModule?.typeId === 'sports_match') {
      return [
        { 
          title: '比赛类型', 
          dataIndex: 'matchType', 
          key: 'matchType',
          render: (type: string) => {
            const colorMap: Record<string, string> = { '足球': 'green', '篮球': 'orange', '电竞': 'purple' };
            return <Tag color={colorMap[type]}>{type}</Tag>;
          }
        },
        { 
          title: '对战队伍', 
          key: 'teams', 
          render: (_: any, record: any) => `${record.teamA || ''} VS ${record.teamB || ''}` 
        },
        { title: '对战日期', dataIndex: 'matchTime', key: 'matchTime' },
        { 
          title: '赔率', 
          key: 'odds', 
          render: (_: any, record: any) => {
            if (record.oddsDraw) {
              return `${record.teamA}: ${record.oddsA?.toFixed(2)} / 平: ${record.oddsDraw?.toFixed(2)} / ${record.teamB}: ${record.oddsB?.toFixed(2)}`;
            }
            return `${record.teamA}: ${record.oddsA?.toFixed(2)} / ${record.teamB}: ${record.oddsB?.toFixed(2)}`;
          }
        },
        { 
          title: '比赛状态', 
          dataIndex: 'matchStatus', 
          key: 'matchStatus',
          render: (status: string) => {
            const colorMap: Record<string, string> = { '未开始': 'blue', '进行中': 'green', '已结束': 'default' };
            return <Tag color={colorMap[status]}>{status}</Tag>;
          }
        },
        { 
          title: '跳转链接', 
          dataIndex: 'jumpUrl', 
          key: 'jumpUrl',
          ellipsis: true,
          render: (url: string) => (
            <Tooltip title={url}>
              <Text ellipsis style={{ maxWidth: 200 }}>
                {url}
              </Text>
            </Tooltip>
          )
        },
        { title: '最后修改人', dataIndex: 'updatedBy', key: 'updatedBy' },
        { title: '最后修改时间', dataIndex: 'updatedAt', key: 'updatedAt' },
        {
          title: '操作',
          key: 'action',
          width: 150,
          render: (_: any, record: any) => (
            <Space>
              <Button size="small" icon={<EditOutlined />} onClick={() => handleEditCard(record)}>
                编辑
              </Button>
              <Popconfirm 
                title="确定要删除这条卡片吗?" 
                onConfirm={() => handleDeleteCard(record.id)}
              >
                <Button danger size="small" icon={<DeleteOutlined />}>
                  删除
                </Button>
              </Popconfirm>
            </Space>
          ),
        },
      ];
    } else if (currentModule?.typeId === 'banner') {
      return [
        { title: '图片', dataIndex: 'imageUrl', key: 'imageUrl', render: (u: string) => <img src={u} alt="" style={{ width: 120, borderRadius: 8 }} /> },
        { title: '跳转', key: 'jump', render: (_: any, r: any) => r.jumpType === 'fixedUrl' ? r.jumpUrl : JSON.stringify(r.jumpParams || {}) },
        { title: '排序', dataIndex: 'sortWeight', key: 'sortWeight' },
        { title: '启用', dataIndex: 'isEnabled', key: 'isEnabled', render: (v: boolean) => <Switch checked={v} disabled /> },
      ];
    } else if (currentModule?.typeId === 'broadcast') {
      return [
        { title: '内容', dataIndex: 'message', key: 'message' },
        { title: '启用', dataIndex: 'isEnabled', key: 'isEnabled', render: (v: boolean) => <Switch checked={v} disabled /> },
      ];
    } else if (currentModule?.typeId === 'game_category') {
      return [
        { title: '名称', dataIndex: 'name', key: 'name' },
        { title: '样式', dataIndex: 'style', key: 'style' },
        { title: '图标', dataIndex: 'iconUrl', key: 'iconUrl', render: (u: string) => <img src={u} alt="" style={{ width: 36 }} /> },
        { title: '排序', dataIndex: 'sortWeight', key: 'sortWeight' },
      ];
    } else if (currentModule?.typeId === 'vendor') {
      return [
        { title: '厂商', dataIndex: 'name', key: 'name' },
        { title: 'Logo', dataIndex: 'logoUrl', key: 'logoUrl', render: (u: string) => <img src={u} alt="" style={{ width: 80 }} /> },
        { title: '排序', dataIndex: 'sortWeight', key: 'sortWeight' },
      ];
    } else if (currentModule?.typeId === 'game') {
      return [
        { title: '名称', dataIndex: 'name', key: 'name' },
        { title: '厂商', dataIndex: 'vendor', key: 'vendor' },
        { title: '封面', dataIndex: 'coverUrl', key: 'coverUrl', render: (u: string) => <img src={u} alt="" style={{ width: 100, borderRadius: 8 }} /> },
        { title: '标签', dataIndex: 'tag', key: 'tag' },
        { title: '排序', dataIndex: 'sortWeight', key: 'sortWeight' },
      ];
    } else if (currentModule?.typeId === 'footer_text') {
      return [
        { title: '文案', dataIndex: 'text', key: 'text' },
      ];
    } else if (currentModule?.typeId === 'footer_contacts') {
      return [
        { title: '平台', dataIndex: 'platform', key: 'platform' },
        { title: '链接', dataIndex: 'url', key: 'url' },
      ];
    }
    return [];
  };

  // —— 以下为模拟数据 ——
  const [banners] = useState<any[]>([
    { id: 'b1', imageUrl: 'https://picsum.photos/1200/300?1', jumpType: 'fixedUrl', jumpUrl: 'https://example.com/promo', sortWeight: 100, isEnabled: true },
    { id: 'b2', imageUrl: 'https://picsum.photos/1200/300?2', jumpType: 'params', jumpParams: { path: '/promo', id: '2001' }, sortWeight: 90, isEnabled: true },
  ]);
  const [broadcasts] = useState<any[]>([
    { id: 'bc1', message: '每日首充返利额外3%，祝您畅快！', isEnabled: true },
  ]);
  const [categories] = useState<any[]>([
    { id: 'c1', name: '热门', style: 'badge', iconUrl: 'https://picsum.photos/64?1', sortWeight: 100 },
    { id: 'c2', name: '体育', style: 'square', iconUrl: 'https://picsum.photos/64?2', sortWeight: 90 },
    { id: 'c3', name: '真人视讯', style: 'square', iconUrl: 'https://picsum.photos/64?3', sortWeight: 80 },
    { id: 'c4', name: '老虎机', style: 'square', iconUrl: 'https://picsum.photos/64?4', sortWeight: 70 },
    { id: 'c5', name: '捕鱼', style: 'square', iconUrl: 'https://picsum.photos/64?5', sortWeight: 60 },
    { id: 'c6', name: '棋牌', style: 'square', iconUrl: 'https://picsum.photos/64?6', sortWeight: 50 },
  ]);
  const [vendorsData] = useState<any[]>([
    { id: 'v1', name: 'DreamGaming', logoUrl: 'https://picsum.photos/160/120?dg', sortWeight: 100 },
    { id: 'v2', name: 'Evolution', logoUrl: 'https://picsum.photos/160/120?evo', sortWeight: 90 },
  ]);
  const [gamesData] = useState<any[]>([
    { id: 'g1', name: 'Baccarat Live', vendor: 'DG', coverUrl: 'https://picsum.photos/200/260?g1', tag: 'LIVE', sortWeight: 100 },
    { id: 'g2', name: 'Xóc Đĩa', vendor: 'EVO', coverUrl: 'https://picsum.photos/200/260?g2', tag: 'LIVE', sortWeight: 95 },
    { id: 'g3', name: 'Aztec Slots', vendor: 'PG', coverUrl: 'https://picsum.photos/200/260?g3', tag: 'Slots', sortWeight: 90 },
    { id: 'g4', name: 'Mahjong Ways 2', vendor: 'PG', coverUrl: 'https://picsum.photos/200/260?g4', tag: 'Slots', sortWeight: 85 },
  ]);
  const [footerTexts] = useState<any[]>([
    { id: 'ft1', text: 'AA.LIVE是领先的线上娱乐平台，受马耳他与PAGCOR合规监管。' },
  ]);
  const [footerContacts] = useState<any[]>([
    { id: 'fc1', platform: 'Telegram', url: 'https://t.me/example' },
    { id: 'fc2', platform: 'Facebook', url: 'https://facebook.com/example' },
    { id: 'fc3', platform: 'Twitter', url: 'https://twitter.com/example' },
  ]);

  return (
    <div style={{ padding: 24 }}>
      <Card>
        <h2><AppstoreOutlined /> 卡片管理</h2>
        <p style={{ color: '#666' }}>管理和配置卡片模块及其卡片数据，首期仅支持首页</p>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <Space>
            <Button onClick={() => {
              // 重置演示数据：仅 banner/notice/hot/footer*
              const demoHot = {
                id: 'hot',
                name: '热门模块',
                type: '热门',
                typeId: 'hot',
                page: 'home',
                CardType: 'hot',
                UIType: 'game.hscroll',
                AppLink: '',
                description: '统一的热门模块（标签+元素）',
                status: '已启用',
                cardCount: 24,
                updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                updatedBy: getCurrentUser(),
                hotContent: {
                  labels: [
                    { key: 'hot_game', name: 'Hot Game' },
                    { key: 'live_brands', name: 'Live Brands' }
                  ],
                  itemsByLabel: {
                    hot_game: genLive(10),
                    live_brands: genLive(8)
                  }
                }
              } as any;
              const sportsModule = {
                id: 'sports_module',
                name: '体育模块',
                type: '体育',
                typeId: 'sports',
                page: 'home',
                CardType: 'sports',
                UIType: 'sports.hscroll',
                description: '体育厂商入口',
                status: '已启用',
                cardCount: 6,
                updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                updatedBy: getCurrentUser(),
                content: {
                  labels: [{ key: 'vendors', name: 'Vendors' }],
                  elements: [
                    { id: 'sv1', title: 'SBOBET', elementType: 'vendor', logoUrl: 'https://picsum.photos/160/120?s1', vendor: 'SBO' },
                    { id: 'sv2', title: 'IM Sports', elementType: 'vendor', logoUrl: 'https://picsum.photos/160/120?s2', vendor: 'IM' },
                    { id: 'sv3', title: 'BTI', elementType: 'vendor', logoUrl: 'https://picsum.photos/160/120?s3', vendor: 'BTI' },
                    { id: 'sv4', title: 'CMD', elementType: 'vendor', logoUrl: 'https://picsum.photos/160/120?s4', vendor: 'CMD' },
                    { id: 'sv5', title: 'UG', elementType: 'vendor', logoUrl: 'https://picsum.photos/160/120?s5', vendor: 'UG' },
                    { id: 'sv6', title: 'SBTech', elementType: 'vendor', logoUrl: 'https://picsum.photos/160/120?s6', vendor: 'SBTech' }
                  ]
                }
              } as any;
              const demo = [
                modules.find(m => m.typeId === 'banner'),
                modules.find(m => m.typeId === 'broadcast'),
                demoHot,
                sportsModule,
                modules.find(m => m.typeId === 'footer_text'),
                modules.find(m => m.typeId === 'footer_contacts')
              ].filter(Boolean) as any[];
              setModules(demo);
              message.success('已重置为演示数据（热门模块+多标签/元素）');
            }}>重置演示数据</Button>
          </Space>
          <Button type="primary" onClick={() => { moduleForm.resetFields(); moduleForm.setFieldsValue({ page: 'home', jumpType: 'fixedUrl' }); setModuleAddVisible(true); }}>新增模块</Button>
        </div>
        <Table 
          columns={moduleColumns} 
          dataSource={modules} 
          rowKey="id" 
          pagination={{ pageSize: 10, showTotal: (total) => `共 ${total} 个模块` }} 
        />
      </Card>

      <Modal
        title={<><AppstoreOutlined /> {currentModule?.name} - 卡片列表</>}
        open={cardModalVisible}
        onCancel={() => setCardModalVisible(false)}
        footer={[<Button onClick={() => setCardModalVisible(false)}>关闭</Button>]}
        width={1400}
        destroyOnClose
      >
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <Tag color="blue" style={{ fontSize: 14, padding: '4px 12px' }}>
              共 {currentCards.length} 条卡片数据
            </Tag>
          </div>
          <Button type="primary" icon={<PlusOutlined />} onClick={handleAddCard}>
            新增卡片
          </Button>
        </div>

        <Table 
          columns={getCardColumns()} 
          dataSource={currentCards} 
          rowKey="id" 
          pagination={{ pageSize: 10, showTotal: (total) => `共 ${total} olymer条` }} 
        />
      </Modal>

      <Modal
        title={editingModule ? '编辑模块' : '新增模块'}
        open={moduleAddVisible}
        onCancel={() => setModuleAddVisible(false)}
        onOk={() => {
          moduleForm.validateFields().then(values => {
            const now = dayjs().format('YYYY-MM-DD HH:mm:ss');
            const currentUser = getCurrentUser();
            const typeMap: Record<string, string> = {
              banner: '轮播图',
              broadcast: '广播消息',
              game_category: '游戏分类',
              vendor: '游戏厂商',
              game: '子游戏',
              live_room: '直播间卡片',
              sports_match: '体育对战卡片',
              footer_text: '底部文案',
              footer_contacts: '底部联系方式',
            };
            const counts: Record<string, number> = {
              banner: banners.length,
              broadcast: broadcasts.length,
              game_category: categories.length,
              vendor: vendorsData.length,
              game: gamesData.length,
              live_room: liveCards.length,
              sports_match: sportsCards.length,
              footer_text: footerTexts.length,
              footer_contacts: footerContacts.length,
            };
              const computedAppLink = values.jumpType === 'fixedUrl'
                ? (values.jumpUrl || '')
                : (values.jumpParams ? JSON.stringify(values.jumpParams) : '');
              const newModule = {
                id: editingModule?.id || Date.now().toString(),
              name: values.name || typeMap[values.typeId],
              type: typeMap[values.typeId],
              typeId: values.typeId,
              page: values.page,
                CardType: values.typeId,
                UIType: values.uiCode,
                AppLink: computedAppLink,
              description: values.description || '',
              status: '已启用',
              cardCount: counts[values.typeId] || 0,
              updatedAt: now,
              updatedBy: currentUser,
              uiCode: values.uiCode,
              dataSource: values.dataSource,
              jumpType: values.jumpType,
              jumpUrl: values.jumpType === 'fixedUrl' ? values.jumpUrl : undefined,
              jumpParams: values.jumpType === 'params' ? values.jumpParams : undefined,
            } as any;
            setModules(prev => {
              if (editingModule) {
                return prev.map(m => (m.id === editingModule.id ? { ...m, ...newModule } : m));
              }
              return [newModule, ...prev];
            });
            setModuleAddVisible(false);
            setEditingModule(null);
          });
        }}
        destroyOnClose
      >
        <Form form={moduleForm} layout="vertical" initialValues={{ page: 'home', jumpType: 'fixedUrl' }}>
          <Form.Item name="page" label="页面" rules={[{ required: true }]}>
            <Select options={[{ label: '首页', value: 'home' }]} />
          </Form.Item>
          <Form.Item name="typeId" label="卡片类型 (CardType)" rules={[{ required: true }]}> 
            <Select
              options={[
                { label: '轮播图', value: 'banner' },
                { label: '广播消息', value: 'broadcast' },
                { label: '游戏分类', value: 'game_category' },
                { label: '游戏厂商', value: 'vendor' },
                { label: '子游戏', value: 'game' },
                { label: '直播间卡片(热门直播排序)', value: 'live_room' },
                { label: '体育对战卡片', value: 'sports_match' },
                { label: '底部文案', value: 'footer_text' },
                { label: '底部联系方式(社媒)', value: 'footer_contacts' },
              ]}
            />
          </Form.Item>
          <Form.Item name="name" label="模块名称">
            <Input placeholder="可选，不填将使用类型名称" />
          </Form.Item>
          <Form.Item name="uiCode" label="页面风格 (UIType)">
            <Input placeholder="如 banner.default / vendor.grid 等" />
          </Form.Item>
          <Form.Item name="dataSource" label="数据源">
            <Input placeholder="接口地址或数据集Key，如 /api/home/banner" />
          </Form.Item>
          <Form.Item name="jumpType" label="跳转 (AppLink) 类型" rules={[{ required: true }]}>
            <Select options={[{ label: '固定URL', value: 'fixedUrl' }, { label: '参数化', value: 'params' }]} />
          </Form.Item>
          <Form.Item noStyle shouldUpdate>
            {() => {
              const jt = moduleForm.getFieldValue('jumpType');
              if (jt === 'fixedUrl') {
                return (
                  <Form.Item name="jumpUrl" label="AppLink（固定URL）">
                    <Input placeholder="https://example.com/path" />
                  </Form.Item>
                );
              }
              if (jt === 'params') {
                return (
                  <Form.Item name="jumpParams" label="AppLink（参数化 JSON）">
                    <Input.TextArea placeholder='例如 {"gameId":"xxx"}' autoSize={{ minRows: 2, maxRows: 6 }} />
                  </Form.Item>
                );
              }
              return null;
            }}
          </Form.Item>
          <Form.Item name="description" label="描述">
            <Input.TextArea placeholder="模块描述（可选）" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={editingCard ? '编辑卡片' : '新增卡片'}
        open={cardEditVisible}
        onOk={handleSaveCard}
        onCancel={() => {
          setCardEditVisible(false);
          cardForm.resetFields();
          setEditingCard(null);
        }}
        width={600}
        destroyOnClose
      >
        <Form form={cardForm} layout="vertical">
          {currentModule?.typeId === 'live_room' && (
            <>
              <Form.Item 
                label="直播间标题" 
                name="title" 
                rules={[{ required: true, message: '请输入直播间标题' }]}
              >
eben                <Input placeholder="请输入直播间标题" />
              </Form.Item>
              <Form.Item 
                label="主播名称" 
                name="hostName" 
                rules={[{ required: true, message: '请输入主播名称' }]}
              >
                <Input placeholder="请输入主播名称" />
              </Form.Item>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="热门标签" name="hotTag">
                    <Select placeholder="请选择热门标签" allowClear>
                      <Option value="热门">热门</Option>
                      <Option value="推荐">推荐</Option>
                      <Option value="福利">福利</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="关联游戏" name="gameName">
                    <Input placeholder="请输入关联游戏" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item 
                    label="观看人数" 
                    name="viewerCount" 
                    rules={[{ required: true, message: '请输入观看人数' }]}
                  >
                    <InputNumber placeholder="请输入观看人数" style={{ width: '100%' }} min={0} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item 
                    label="直播状态" 
                    name="liveStatus" 
                    rules={[{ required: true, message: '请选择直播状态' }]}
                  >
                    <Select placeholder="请选择直播状态">
                      <Option value="直播中">直播 קר中</Option>
                      <Option value="预告中">预告中</Option>
                      <Option value="已结束">已结束</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item 
                label="跳转链接" 
                name="jumpUrl" 
                rules={[{ required: true, message: '请输入跳转链接不在乎' }]}
              >
                <Input placeholder="请输入跳转链接，如: https://example.com/live/room/123" />
              </Form.Item>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item 
                    label="排序权重" 
                    name="sortWeight" 
                    rules={[{ required: true, message: '请输入排序权重' }]}
                  >
                    <InputNumber placeholder="请输入排序权重" style={{ width: '100%' }} min={0} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="是否启用" name="isEnabled" valuePropName="checked">
                    <Switch />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          
          {currentModule?.typeId === 'sports_match' && (
            <>
              <Form.Item 
                label="比赛类型" 
                name="matchType" 
                rules={[{ required: true, message: '请选择比赛类型' }]}
              >
                <Select placeholder="请选择比赛类型">
                  <Option value="足球">足球</Option>
                  <Option value="篮球">篮球</Option>
                  <Option value="电竞">电竞</Option>
                </Select>
              </Form.Item>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item 
                    label="队伍A名称" 
                    name="teamA" 
                    rules={[{ required: true, message: '请输入队伍A名称' }]}
                  >
                    <Input placeholder="请输入队伍A名称" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item 
                    label="队伍B名称" 
                    name="teamB" 
                    rules={[{ required: true, message: '请输入队伍B名称' }]}
                  >
                    <Input placeholder="请输入队伍B名称" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item 
                label="对战日期" 
                name="matchTime" 
                rules={[{ required: true, message: '请选择对战日期' }]}
              >
                <Input placeholder="格式: 2025-01-27 16:30" />
              </Form.Item>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label="队伍A赔率" name="oddsA">
                    <InputNumber placeholder="赔率" style={{ width: '100%' }} min={0} step={0.1} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="平局赔率" name="oddsDraw">
                    <InputNumber placeholder="赔率" style={{ width: '100%' }} min={0} step={0.1} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="队伍B赔率" name="oddsB">
                    <InputNumber placeholder="赔率" style={{ width: '100%' }} min={0} step={0.1} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item 
                label="比赛状态" 
                name="matchStatus" 
                rules={[{ required: true, message: '请选择比赛状态' }]}
              >
                <Select placeholder="请选择比赛状态">
                  <Option value="未开始">未开始</Option>
                  <Option value="进行中">进行中</Option>
                  <Option value="已结束">已结束</Option>
                </Select>
              </Form.Item>
              <Form.Item 
                label="跳转链接" 
                name="jumpUrl" 
                rules={[{ required: true, message: '请输入跳转链接' }]}
              >
                <Input placeholder="请输入跳转链接，如: https://example.com/sports/match/456" />
              </Form.Item>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item 
                    label="排序权重" 
                    name="sortWeight" 
                    rules={[{ required: true, message: '请输入排序权重' }]}
                  >
                    <InputNumber placeholder="请输入排序权重" style={{ width: '100%' }} min={0} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="是否启用" name="isEnabled" valuePropName="checked">
                    <Switch />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </Form>
      </Modal>

      <Modal
        title="热门内容"
        open={liveHotVisible}
        onCancel={() => setLiveHotVisible(false)}
        width={900}
        footer={[
          <Button key="close" onClick={() => setLiveHotVisible(false)}>关闭</Button>,
          <Button key="save" type="primary" onClick={() => {
            // 写回模块
            setModules(prev => prev.map(m => {
              if (m.typeId !== 'hot') return m;
              const copy: any = { ...m, hotContent: { ...(m as any).hotContent } };
              if (!copy.hotContent) copy.hotContent = { labels: [{ key: 'live_room', name: 'Hot Game' }], itemsByLabel: {} };
              copy.hotContent.itemsByLabel = { ...(copy.hotContent.itemsByLabel || {}), [currentHotLabel]: liveHotItems };
              copy.hotContent.labels = hotLabels;
              return copy;
            }));
            setLiveHotVisible(false);
            message.success('热门内容已保存（本地示例）');
          }}>保存</Button>
        ]}
        destroyOnClose
      >
        <div style={{ marginBottom: 12 }}>
          <Space>
            <span>标签：</span>
            <Radio.Group
              value={currentHotLabel}
              onChange={(e) => {
                // 切换标签前，先写回当前修改
                writeBackHotItems(currentHotLabel, liveHotItems);
                const nextLabel = e.target.value;
                setCurrentHotLabel(nextLabel);
                // 读取新标签数据
                const hot = modules.find(m => m.typeId === 'hot') as any;
                const nextItems = hot?.hotContent?.itemsByLabel?.[nextLabel] || genMockLive();
                setLiveHotItems(nextItems);
                setRenameName(hotLabels.find(l => l.key === nextLabel)?.name || '');
              }}
            >
              {hotLabels.map(l => (
                <Radio.Button key={l.key} value={l.key}>{l.name}</Radio.Button>
              ))}
            </Radio.Group>
            <Button size="small" onClick={addHotLabel}>新增标签</Button>
            <Button size="small" danger onClick={deleteHotLabel}>删除当前</Button>
            <span>重命名：</span>
            <Input size="small" style={{ width: 160 }} value={renameName} onChange={(e) => {
              const v = e.target.value;
              setRenameName(v);
              setHotLabels(prev => prev.map(l => l.key === currentHotLabel ? { ...l, name: v } : l));
            }} />
          </Space>
        </div>
        <div style={{ marginBottom: 12 }}>
          <Space>
            <span>快捷排序：</span>
            <Radio.Group value={liveHotSort} onChange={(e) => applyLiveHotSort(e.target.value)}>
              <Radio.Button value="heat">按热度</Radio.Button>
              <Radio.Button value="gameType">按游戏类型</Radio.Button>
              <Radio.Button value="startTime">按开播时间</Radio.Button>
            </Radio.Group>
          </Space>
        </div>
        <Table
          rowKey="id"
          dataSource={liveHotItems}
          pagination={false}
          columns={[
            { title: '类型', dataIndex: 'elementType', render: (t: HotItemType) => ({ live: '直播', game: '子游戏', vendor: '厂商' }[t]) },
            { title: '标题', dataIndex: 'title' },
            { title: '热度', dataIndex: 'heat', render: (v: number, r: any) => r.elementType==='live' ? v : '-' },
            { title: '游戏类型', dataIndex: 'gameType', render: (v: any, r: any) => r.elementType!=='vendor' ? v || '-' : '-' },
            { title: '开播时间', dataIndex: 'startTime', render: (v: any, r: any) => r.elementType==='live' && v ? dayjs(v).format('YYYY-MM-DD HH:mm:ss') : '-' },
            { title: '灰度', dataIndex: 'isGray', render: (v: boolean, r: any, idx: number) => r.elementType==='live' ? <Switch checked={!!v} onChange={(checked) => setLiveHotItems(list => list.map((it, i) => i===idx? { ...it, isGray: checked } : it))} /> : '-' },
            { title: '状态', dataIndex: 'status', render: (v: string, r: any) => r.elementType==='live' ? (v === 'online' ? <Tag color="green">上架</Tag> : <Tag>下架</Tag>) : '-' },
            {
              title: '操作',
              width: 160,
              render: (_: any, __: any, idx: number) => (
                <Space>
                  {liveHotItems[idx]?.elementType==='live' && (
                    <Button size="small" onClick={() => setLiveHotItems(list => list.map((it, i) => i===idx? { ...it, status: it.status==='online'?'offline':'online' } : it))}>
                      {liveHotItems[idx]?.status === 'online' ? '下架' : '上架'}
                    </Button>
                  )}
                  <Button size="small" onClick={() => moveLiveHot(idx, -1)} disabled={idx === 0}>上移</Button>
                  <Button size="small" onClick={() => moveLiveHot(idx, 1)} disabled={idx === liveHotItems.length - 1}>下移</Button>
                </Space>
              )
            }
          ]}
        />
      </Modal>
    </div>
  );
};

export default CardManagement;

